/* Fresh Magnets: one "Social feature" answer per order.
   The answer lives in the cart attribute "Social feature" (Yes/No) and is mirrored onto every
   cart line's "Social feature" property, because line properties print on the packing slip.
   window.fmSetSocial(value) does both. It is called by the toggle next to the order note
   (snippets/fresh-social-cart.liquid) and by the product page toggle
   (snippets/fresh-social-consent.liquid), so both always agree. */
(function () {
  if (window.__fmSocialBound) return;
  window.__fmSocialBound = true;

  var KEY = 'Social feature';
  var pending = Promise.resolve();

  function post(url, body) {
    var cfg = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    return fetch(url, Object.assign({}, cfg, { body: JSON.stringify(body) })).then(function (r) { return r.json(); });
  }

  // Shopify HTML-escapes property text, so decode before resending or quotes double-escape.
  var ta = document.createElement('textarea');
  function decode(v) {
    if (typeof v !== 'string') return v;
    ta.innerHTML = v;
    return ta.value;
  }

  function lockCheckout(on) {
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (on) { b.dataset.fmSocialLock = '1'; b.disabled = true; }
      else if (b.dataset.fmSocialLock) { delete b.dataset.fmSocialLock; b.disabled = false; }
    });
  }

  function sync(value) {
    lockCheckout(true);
    var root = (window.routes && window.routes.cart_url) || '/cart';
    return post(root + '/update.js', { attributes: { 'Social feature': value } })
      .then(function () { return fetch(root + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props[KEY] === undefined || props[KEY] === value) return;
          var next = {};
          Object.keys(props).forEach(function (k) { next[k] = decode(props[k]); });
          next[KEY] = value;
          chain = chain.then(function () { return post(root + '/change.js', { id: item.key, quantity: item.quantity, properties: next }); });
        });
        return chain;
      })
      .catch(function () {})
      .then(function () { lockCheckout(false); });
  }

  // Queue calls so a quick on/off/on never races.
  window.fmSetSocial = function (value) {
    // Every toggle on the page (drawer, cart page, product page) shows the same answer.
    var on = value === 'Yes';
    document.querySelectorAll('[data-fm-social-cart-cb], [data-fm-social]').forEach(function (c) { c.checked = on; });
    document.querySelectorAll('[data-fm-social-cart-val], [data-fm-social-val]').forEach(function (i) { i.value = value; });
    pending = pending.then(function () { return sync(value); });
    return pending;
  };

  // Cart toggle (drawer and cart page): keep every copy of the toggle and hidden field in step.
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-fm-social-cart-cb]');
    if (!cb) return;
    window.fmSetSocial(cb.checked ? 'Yes' : 'No');
  });
})();
